export const stockCategories = {
  success: true,
  data: {
    amc_detail: null,
    search_nav: [
      {
        title: 'Stock Categories',
        navigations: [
          {
            header: 'All Stocks',
            header_link: '/stocks/category/all',
          },
          {
            header: 'By Market Cap',
            sub_headers: [
              {
                header: 'Large Cap Stocks',
                header_link: '/stocks/category/large-cap-stocks',
              },
              {
                header: 'Mid Cap Stocks',
                header_link: '/stocks/category/mid-cap-stocks',
              },
              {
                header: 'Small Cap Stocks',
                header_link: '/stocks/category/small-cap-stocks',
              },
            ],
          },
          {
            header: 'By Performance',
            sub_headers: [
              {
                header: 'Top Gainers Stocks',
                header_link: '/stocks/category/top-gainers',
              },
              {
                header: 'Top Losers Stocks',
                header_link: '/stocks/category/top-losers',
              },
              {
                header: '52 Week High Stocks',
                header_link: '/stocks/category/52-week-high',
              },
              {
                header: '52 Week Low Stocks',
                header_link: '/stocks/category/52-week-low',
              },

              {
                header: 'Penny Stocks',
                header_link: '/stocks/category/penny-stocks',
              },
              {
                header: 'Blue Chip Stocks',
                header_link: '/stocks/category/blue-chip-stocks',
              },
              {
                header: 'Multibagger Stocks',
                header_link: '/stocks/category/multibagger-stocks',
              },
              {
                header: 'Undervalued Stocks',
                header_link: '/stocks/category/undervalued-stocks',
              },
              {
                header: 'Upper Circuit Stocks',
                header_link: '/stocks/category/only-buyers',
              },
              {
                header: 'Lower Circuit Stocks',
                header_link: '/stocks/category/only-sellers',
              },
              {
                header: 'Dividend Stocks',
                header_link: '/stocks/category/dividend-stocks',
              },
              {
                header: 'Most Active Stocks',
                header_link: '/stocks/category/most-active',
              },
              {
                header: 'Stocks to Buy Today',
                header_link: '/stocks/category/buy-stocks',
              },
              {
                header: 'Intraday Stocks for Today',
                header_link: '/stocks/category/intraday-stocks',
              },
              {
                header: 'Best Monopoly Stocks',
                header_link: '/stocks/category/best-monopoly-stocks',
              },
              {
                header: 'Expensive Stocks',
                header_link: '/stocks/category/expensive-stocks',
              },
              {
                header: 'Defensive Stocks',
                header_link: '/stocks/category/defensive-stocks',
              },
              {
                header: 'Value Stocks',
                header_link: '/stocks/category/value-stocks',
              },
              {
                header: 'Most Volatile Stocks',
                header_link: '/stocks/category/most-volatile-stocks',
              },
              {
                header: 'Swing Trading Stocks',
                header_link: '/stocks/category/swing-trading-stocks',
              },
            ],
          },
          {
            header: 'By Industry',
            sub_headers: [
              {
                header: 'Semiconductor Stocks',
                header_link: '/stocks/category/semiconductor-stocks',
              },
              {
                header: 'Defence Stocks',
                header_link: '/stocks/category/defence',
              },
              {
                header: 'Green Energy Stocks',
                header_link: '/stocks/category/green-energy-stocks',
              },
              {
                header: 'Solar Energy Stocks',
                header_link: '/stocks/category/solar-energy-stocks',
              },
              {
                header: 'Green Hydrogen Stocks',
                header_link: '/stocks/category/green-hydrogen-stocks',
              },
              {
                header: 'Railway Stocks',
                header_link: '/stocks/category/railway-stocks',
              },
              {
                header: 'Artificial Intelligence (AI) Stocks',
                header_link:
                  '/stocks/category/artificial-intelligence-ai-stocks',
              },
              {
                header: 'FMCG Stocks',
                header_link: '/stocks/category/fmcg-stocks',
              },
              {
                header: 'Sugar Stocks',
                header_link: '/stocks/category/sugar-stocks',
              },

              {
                header: 'Electric Vehicle (EV) Stocks',
                header_link: '/stocks/category/ev-stocks',
              },
              {
                header: 'Infrastructure Stocks',
                header_link: '/stocks/category/infrastructure-stocks',
              },
              {
                header: 'Ethanol Stocks',
                header_link: '/stocks/category/ethanol-stocks',
              },
              {
                header: 'Banking Stocks',
                header_link: '/stocks/category/banking-stocks',
              },
              {
                header: 'Financial Services Stocks',
                header_link: '/stocks/category/finance-stocks',
              },
              {
                header: 'Information Technology (IT) Stocks',
                header_link: '/stocks/category/it-stocks',
              },
              {
                header: 'Pharma Stocks',
                header_link: '/stocks/category/pharma-stocks',
              },
              {
                header: 'Automobiles / Auto Components Stocks',
                header_link: '/stocks/category/auto',
              },
              {
                header: 'Cement Stocks',
                header_link: '/stocks/category/cement-stocks',
              },
              {
                header: 'Construction Stocks',
                header_link: '/stocks/category/construction-stocks',
              },
              {
                header: 'Real Estate Stocks',
                header_link: '/stocks/category/real-estate-stocks',
              },
              {
                header: 'Telecom Stocks',
                header_link: '/stocks/category/telecom-stocks',
              },
              {
                header: 'Chemical Stocks',
                header_link: '/stocks/category/chemical-stocks',
              },
              {
                header: 'Logistics Stocks',
                header_link: '/stocks/category/logistics-stocks',
              },
              {
                header: 'Media Stocks',
                header_link: '/stocks/category/media-stocks',
              },
              {
                header: 'Retailing Stocks',
                header_link: '/stocks/category/retailing-stocks',
              },
              {
                header: 'Healthcare Stocks',
                header_link: '/stocks/category/healthcare-stocks',
              },
              {
                header: 'Hospitality / Hotel Stocks',
                header_link: '/stocks/category/hotels-resort-stocks',
              },
              {
                header: 'Textiles and Apparel Stocks',
                header_link: '/stocks/category/textiles-stocks',
              },
              {
                header: 'Insurance Stocks',
                header_link: '/stocks/category/insurance-stocks',
              },
              {
                header: 'Electronics Stocks',
                header_link: '/stocks/category/electronics-stocks',
              },
              {
                header: 'PSU Stocks',
                header_link: '/stocks/category/psu-stocks',
              },
              {
                header: 'Wires and Cables Stocks',
                header_link: '/stocks/category/cables-stocks',
              },
              {
                header: 'Agriculture Stocks',
                header_link: '/stocks/category/agriculture-stocks',
              },
              {
                header: 'Air Conditioners Stocks',
                header_link: '/stocks/category/air-conditioners-stocks',
              },
              {
                header: 'Tea and Coffee Stocks',
                header_link: '/stocks/category/tea-coffee-stocks',
              },
              {
                header: 'Stock Broking Stocks',
                header_link: '/stocks/category/stock-broking-stocks',
              },
              {
                header: 'Consumer Food Stocks',
                header_link: '/stocks/category/consumer-food-stocks',
              },

              {
                header: 'Breweries and Distilleries Stocks',
                header_link: '/stocks/category/breweries-distilleries-stocks',
              },
              {
                header: 'Carbon Stocks',
                header_link: '/stocks/category/carbon-stocks',
              },
              {
                header: 'Tyres Stocks',
                header_link: '/stocks/category/tyres-stocks',
              },
              {
                header: 'Small Finance Bank Stocks',
                header_link: '/stocks/category/small-finance-bank-stocks',
              },
              {
                header: 'Aquaculture Stocks',
                header_link: '/stocks/category/aquaculture-stocks',
              },
              {
                header: 'Gas Distribution Stocks',
                header_link: '/stocks/category/gas-distribution-stocks',
              },
              {
                header: 'Private Bank Stocks',
                header_link: '/stocks/category/private-bank-stocks',
              },
              {
                header: 'Best Cloud Computing Stocks',
                header_link: '/stocks/category/best-cloud-computing-stocks',
              },
              {
                header: 'Medical Equipment Stocks',
                header_link: '/stocks/category/medical-equipment-stocks',
              },
              {
                header: 'Rubber Stocks',
                header_link: '/stocks/category/rubber-stocks',
              },
              {
                header: 'Airlines Stocks',
                header_link: '/stocks/category/airlines-stocks',
              },
              {
                header: 'Engineering Stocks',
                header_link: '/stocks/category/engineering-stocks',
              },
              {
                header: 'Packaging Stocks',
                header_link: '/stocks/category/packaging-stocks',
              },
              {
                header: 'Footwear Stocks',
                header_link: '/stocks/category/footwear-stocks',
              },
              {
                header: 'Marine Port Stocks',
                header_link: '/stocks/category/marine-port-stocks',
              },
              {
                header: 'Education Stocks',
                header_link: '/stocks/category/education-stocks',
              },
              {
                header: 'Edible Oil Stocks',
                header_link: '/stocks/category/edible-oil-stocks',
              },
              {
                header: 'Travel Stocks',
                header_link: '/stocks/category/travel-stocks',
              },
              {
                header: 'Cybersecurity Stocks',
                header_link: '/stocks/category/cybersecurity-stocks',
              },
              {
                header: 'Wealth Management Stocks',
                header_link: '/stocks/category/wealth-management-stocks',
              },
              {
                header: 'Manufacturing Stocks',
                header_link: '/stocks/category/manufacturing-stocks',
              },
              {
                header: 'Tobacco Stocks',
                header_link: '/stocks/category/tobacco-stocks',
              },
              {
                header: 'AMC Stocks',
                header_link: '/stocks/category/amc-stocks',
              },
              {
                header: 'Real Estate Investment Trust (REIT) Stocks',
                header_link:
                  '/stocks/category/real-estate-investment-trust-reit',
              },
              {
                header: 'Ship Building Stocks',
                header_link: '/stocks/category/ship-building-stocks',
              },
              {
                header: 'Gold Stocks',
                header_link: '/stocks/category/gold-stocks',
              },
              {
                header: 'NBFC Stocks',
                header_link: '/stocks/category/nbfc-stocks',
              },
              {
                header: 'Drone Stocks',
                header_link: '/stocks/category/drone-stocks',
              },
              {
                header: 'Battery Stocks',
                header_link: '/stocks/category/battery-stocks',
              },
              {
                header: 'Waste Management Stocks',
                header_link: '/stocks/category/waste-management-stocks',
              },
            ],
          },
          {
            header: 'By Stock Groups',
            sub_headers: [
              {
                header: 'Adani Group Shares',
                header_link: '/stocks/category/adani-group-shares',
              },
              {
                header: 'Ambani Group Shares',
                header_link: '/stocks/category/ambani-group-shares',
              },
              {
                header: 'Tata Group Shares',
                header_link: '/stocks/category/tata-group-shares',
              },
              {
                header: 'Mahindra and Mahindra Group Shares',
                header_link:
                  '/stocks/category/mahindra-and-mahindra-group-shares',
              },
              {
                header: 'Birla Group Shares',
                header_link: '/stocks/category/birla-group-shares',
              },
              {
                header: 'Larsen and Toubro Group Shares',
                header_link: '/stocks/category/larsen-and-toubro-group-shares',
              },
              {
                header: 'ICICI Group Shares',
                header_link: '/stocks/category/icici-group-shares',
              },
              {
                header: 'Hero Group Shares',
                header_link: '/stocks/category/hero-group-shares',
              },
              {
                header: 'HDFC Group Shares',
                header_link: '/stocks/category/hdfc-group-shares',
              },
              {
                header: 'Wadia Group Shares',
                header_link: '/stocks/category/wadia-group-shares',
              },
              {
                header: 'Jindal Group Shares',
                header_link: '/stocks/category/jindal-group-shares',
              },
              {
                header: 'Murugappa Group Shares',
                header_link: '/stocks/category/murugappa-group-shares',
              },
              {
                header: 'Godrej Group Shares',
                header_link: '/stocks/category/godrej-group-shares',
              },
              {
                header: 'Hinduja Group Shares',
                header_link: '/stocks/category/hinduja-group-shares',
              },
              {
                header: 'Tvs Group Shares',
                header_link: '/stocks/category/tvs-group-shares',
              },
            ],
          },
          {
            header: 'By Corporate Actions & Events',
            sub_headers: [
              {
                header: 'Bonus Shares',
                header_link: '/stocks/category/bonus-shares',
              },
              {
                header: 'Buyback of Shares',
                header_link: '/stocks/category/buyback-of-shares',
              },
              {
                header: 'Upcoming Dividends',
                header_link: '/stocks/category/upcoming-dividends',
              },
            ],
          },
          {
            header: 'Margin Trading Facility (MTF)',
            header_link: '/stocks/category/margin-trading-facility-mtf',
          },
          {
            header: 'ETF / Stock Baskets',
            header_link: '/stocks/etf',
            sub_headers: [
              {
                header: 'Gold ETFs',
                header_link: '/stocks/category/gold-etfs',
              },

              {
                header: 'Debt ETFs',
                header_link: '/stocks/category/debt-etfs',
              },

              {
                header: 'Banking ETFs',
                header_link: '/stocks/category/banking-etfs',
              },
              {
                header: 'International ETFs',
                header_link: '/stocks/category/international-etfs',
              },
            ],
          },
        ],
      },
    ],
  },
}
